import { SchoolOptionAPIResponse } from 'types';

/**
 * @summary utility function to extract school logo
 * @private
 */
export function getImageUrlMap(
  images: SchoolOptionAPIResponse['schoolImages'],
  defaultImgUrl: string = '/theme-assets/click-portal/tablet.png'
): {
  mobile: {
    url: string;
    srcset: string;
    height: number;
    width: number;
  };
  desktop: {
    url: string;
    srcset: string;
    height: number;
    width: number;
  };
} {

  return {
    mobile: {
      url: images?.Mobile?.imageUrl || defaultImgUrl,
      srcset: images?.Mobile?.srcset || '',
      height: images?.Mobile?.height || 0,
      width: images?.Mobile?.width || 0,
    },
    desktop: {
      url: images?.Desktop?.imageUrl || defaultImgUrl,
      srcset: images?.Desktop?.srcset || '',
      height: images?.Desktop?.height || 0,
      width: images?.Desktop?.width || 0,
    }
  };
}
